import { PayloadAction } from '@reduxjs/toolkit';
import { ICountry, IService } from 'dataSources/Typicode/common/types';
import { sortByName } from 'common/utils/sorting';
import { IDirectory } from 'common/types/common/directory';

import { IState } from '../types/state';

interface IAction {
  countries: ICountry[];
  roadsideService: IDirectory[];
  stationCategories: IDirectory[];
  serviceFormats: IDirectory[];
  additionalParams: IDirectory[];
  additionalServices: IDirectory[];
  services: IService[];
}

const initPage = (state: IState, action: PayloadAction<IAction>) => {
  const {
    countries,
    roadsideService,
    stationCategories,
    serviceFormats,
    additionalParams,
    services,
    additionalServices,
  } = action.payload;
  state.countries = countries.sort(sortByName);
  state.roadsideService = roadsideService.sort(sortByName);
  state.stationCategories = stationCategories.sort(sortByName);
  state.serviceFormats = serviceFormats.sort(sortByName);
  state.additionalParams = additionalParams.sort(sortByName);
  state.additionalServices = additionalServices.sort(sortByName);
  state.services = services;
};

export default initPage;
